const referralProgramEN = {
	title: "Sin Fila Referral Program",
	tagline: "Share Sin Fila. Everyone wins.",

	howItWorks: {
		heading: "How it works",
		text: "Every new business gets 14 days free when they join Sin Fila. When you refer someone using your unique code, that turns into something better for both of you.",
	},

	ifYouRefer: {
		heading: "If you refer a business",
		text: "No limit. Notricks. $15 USD credit every time someone you refer makes their first payment",
		bullets: [
			"No limit — refer as many businesses as you like, and earn $15 USD for each one.",
			"Your reward is applied automatically to your account.",
		],
	},

	ifYouWereReferred: {
		heading: "If you were referred",
		text: "You get 2 extra weeks free — 28 days total instead of 14 — so you have more time to try Sin Fila before you're charged anything.",
	},

	howToRefer: {
		heading: "How to refer someone",
		steps: [
			"Find your referral code in your account.",
			"Share it with a business owner you know.",
			"They enter it when they sign up (or within their first 14 days).",
			"Once they make their first payment, your $15 USD reward is added to your account.",
		],
	},

	goodToKnow: {
		heading: "Good to know",
		bullets: [
			"Rewards are credited only after your referral makes their first payment.",
			"If your reward is larger than your next bill, the extra balance carries over to future bills automatically.",
			"If you haven't yet subscribed yourself, any rewards you've earned stay valid for 6 months.",
		],
	},

	cta: {
		text: "Ready to get started?",
		button: "Register now for free",
	},
};

export default referralProgramEN;
